module.exports = __webpack_public_path__ + "img/manual2.cf601112.jpg";